import React from "react";
import {MenuItem, TextField} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";
import {TAGS} from "../../constants";

const DocumentFilters = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="document-filters">
        <div className="field top-margin">
            <TextField label="Category" select={true}
                       type="text"
                       value={forms.sanitizeValue(data.tag)}
                       onChange={(event) => onChange("tag", event.target.value)}
            >
                <MenuItem value="">&nbsp;</MenuItem>
                {Object.entries(TAGS).map(([tag, label]) =>
                    <MenuItem key={tag} value={tag}>
                        {label}
                    </MenuItem>)}
            </TextField>
        </div>
        <div className="field">
            <TextField label="Name"
                       type="text"
                       value={forms.sanitizeValue(data.fileName)}
                       onChange={(event) => onChange("fileName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField label="Size"
                       type="number"
                       value={forms.sanitizeValue(data.size)}
                       onChange={(event) => onChange("size", event.target.value)}
                       inputProps={{
                           min: 0,
                       }}
            />
        </div>
    </div>
}

export default DocumentFilters;
